import {DataFrameColumnDef} from 'data-frames/DataFrameTypes';
import {OptionData} from 'ui-library/menus/MenuConstants';

export function getColumnOptionDatas(
  columns: Array<DataFrameColumnDef>,
  useSystemNames: boolean
): Array<OptionData> {
  return columns.map((column) => ({
    name: column.displayName,
    value: useSystemNames ? column.systemName : column.displayName,
    dataTestAttrs: {
      component: 'DropdownSelector',
      element: 'option',
      key: column.systemName,
    },
  }));
}
